"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = exports.Root = void 0;
const styles_1 = require("@mui/material/styles");
const typography_1 = __importDefault(require("../typography"));
exports.Root = (0, styles_1.styled)("nav")({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "24px",
    flexWrap: "wrap",
    padding: "30px 0"
});
exports.Heading = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    flexBasis: "100%",
    [theme.breakpoints.up("md")]: {
        flexBasis: "auto"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2V4cGxvcmUtYmFyL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxpREFBOEM7QUFDOUMsK0RBQXVDO0FBRTFCLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ2hDLE9BQU8sRUFBRSxNQUFNO0lBQ2YsY0FBYyxFQUFFLFlBQVk7SUFDNUIsVUFBVSxFQUFFLFFBQVE7SUFDcEIsR0FBRyxFQUFFLE1BQU07SUFDWCxRQUFRLEVBQUUsTUFBTTtJQUNoQixPQUFPLEVBQUUsUUFBUTtDQUNsQixDQUFDLENBQUM7QUFFVSxRQUFBLE9BQU8sR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBVSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3hELFNBQVMsRUFBRSxNQUFNO0lBQ2pCLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM1QixTQUFTLEVBQUUsTUFBTTtLQUNsQjtDQUNGLENBQUMsQ0FBQyxDQUFDIn0=